import { jsx as y } from "react/jsx-runtime";
import * as s from "react";
import R, { useState as P, useCallback as C } from "react";
import { c as b } from "../../index-C3-ZVs5E.js";
import { ButtonAlignmentEnum as h, ButtonSizeEnum as f, ButtonShapeEnum as g, ButtonThemeEnum as _ } from "./types.js";
import '../../assets/Button.css';function S(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function N(...e) {
  return (n) => {
    let i = !1;
    const r = e.map((t) => {
      const o = S(t, n);
      return !i && typeof o == "function" && (i = !0), o;
    });
    if (i)
      return () => {
        for (let t = 0; t < r.length; t++) {
          const o = r[t];
          typeof o == "function" ? o() : S(e[t], null);
        }
      };
  };
}
// @__NO_SIDE_EFFECTS__
function v(e) {
  const n = /* @__PURE__ */ B(e), i = s.forwardRef((r, t) => {
    const { children: o, ...c } = r, a = s.Children.toArray(o), p = a.find(X);
    if (p) {
      const u = p.props.children, d = a.map((m) => m === p ? s.Children.count(u) > 1 ? s.Children.only(null) : s.isValidElement(u) ? u.props.children : null : m);
      return /* @__PURE__ */ y(n, { ...c, ref: t, children: s.isValidElement(u) ? s.cloneElement(u, void 0, d) : null });
    }
    return /* @__PURE__ */ y(n, { ...c, ref: t, children: o });
  });
  return i.displayName = `${e}.Slot`, i;
}
var O = /* @__PURE__ */ v("Slot");
// @__NO_SIDE_EFFECTS__
function B(e) {
  const n = s.forwardRef((i, r) => {
    const { children: t, ...o } = i;
    if (s.isValidElement(t)) {
      const c = k(t), a = x(o, t.props);
      return t.type !== s.Fragment && (a.ref = r ? N(r, c) : c), s.cloneElement(t, a);
    }
    return s.Children.count(t) > 1 ? s.Children.only(null) : null;
  });
  return n.displayName = `${e}.SlotClone`, n;
}
var L = Symbol("radix.slottable");
function X(e) {
  return s.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === L;
}
function x(e, n) {
  const i = { ...n };
  for (const r in n) {
    const t = e[r], o = n[r];
    /^on[A-Z]/.test(r) ? t && o ? i[r] = (...a) => {
      const p = o(...a);
      return t(...a), p;
    } : t && (i[r] = t) : r === "style" ? i[r] = { ...t, ...o } : r === "className" && (i[r] = [t, o].filter(Boolean).join(" "));
  }
  return { ...e, ...i };
}
function k(e) {
  var r, t;
  let n = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, i = n && "isReactWarning" in n && n.isReactWarning;
  return i ? e.ref : (n = (t = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : t.get, i = n && "isReactWarning" in n && n.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
const H = "_button_42ph9_2", I = "_active_42ph9_17", V = "_themePrimary_42ph9_20", A = "_themeEditor_42ph9_30", W = "_themeNaked_42ph9_37", j = "_themeOutline_42ph9_45", w = "_shapePill_42ph9_54", T = "_shapeCircle_42ph9_57", D = "_sizeXs_42ph9_60", F = "_sizeSm_42ph9_70", $ = "_sizeMd_42ph9_81", Z = "_sizeLg_42ph9_87", q = "_sizeXl_42ph9_93", G = "_alignLeft_42ph9_99", J = "_alignCenter_42ph9_102", K = "_alignRight_42ph9_105", l = {
  button: H,
  active: I,
  themePrimary: V,
  themeEditor: A,
  themeNaked: W,
  themeOutline: j,
  shapePill: w,
  shapeCircle: T,
  sizeXs: D,
  sizeSm: F,
  sizeMd: $,
  sizeLg: Z,
  sizeXl: q,
  alignLeft: G,
  alignCenter: J,
  alignRight: K
}, M = ({
  onMouseEnter: e,
  onMouseLeave: n
}) => {
  const [i, r] = P(!1), t = C(
    (c) => {
      r(!0), e == null || e(c);
    },
    [e]
  ), o = C(
    (c) => {
      r(!1), n == null || n(c);
    },
    [n]
  );
  return {
    isHovered: i,
    handleMouseEnter: t,
    handleMouseLeave: o
  };
}, ne = R.forwardRef(
  ({
    theme: e,
    shape: n = g.pill,
    size: i = f.md,
    align: r = h.center,
    children: t,
    className: o,
    forceActive: c,
    asChild: a,
    ...p
  }, u) => {
    const d = b(o, l.button, {
      [l.themePrimary]: e === _.primary,
      [l.themeEditor]: e === _.editor,
      [l.themeNaked]: e === _.naked,
      [l.themeOutline]: e === _.outline,
      [l.shapePill]: n === g.pill,
      [l.shapeCircle]: n === g.circle,
      [l.sizeXs]: i === f.xs,
      [l.sizeSm]: i === f.sm,
      [l.sizeMd]: i === f.md,
      [l.sizeLg]: i === f.lg,
      [l.sizeXl]: i === f.xl,
      [l.active]: c,
      [l.alignLeft]: r === h.left,
      [l.alignCenter]: r === h.center,
      [l.alignRight]: r === h.right
    }), { isHovered: m, handleMouseEnter: z, handleMouseLeave: E } = M(p);
    return /* @__PURE__ */ y(
      a ? O : "button",
      {
        ...p,
        ref: u,
        className: d,
        onMouseEnter: z,
        onMouseLeave: E,
        children: typeof t == "function" ? t({ isHovered: m }) : t
      }
    );
  }
);
export {
  ne as Button
};
